import type { Conversation } from '@/types/dashboard'
import type { ChatMessage } from '@/types/chat'

export function dotClass(conv: Conversation): string {
  if (conv.unread_count > 0) return 'dot-new'
  if (conv.status === 'snoozed') return 'dot-snoozed'
  if (conv.status === 'pending') return 'dot-pending'
  return 'dot-open'
}

export function convTime(conv: Conversation): string {
  const ts = conv.created_at
  if (!ts) return ''
  const d = new Date(ts * 1000), now = new Date()
  return d.toDateString() === now.toDateString()
    ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
}

export function convStatusLabel(status: string): string {
  if (status === 'open') return 'Aberta'
  if (status === 'resolved') return 'Resolvida'
  if (status === 'pending') return 'Pendente'
  if (status === 'snoozed') return 'Adiada'
  return status
}

export function fmtTs(ts: number): string {
  const d = new Date(ts * 1000)
  return `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
}

export function senderName(msg: ChatMessage): string {
  return msg.sender?.name || msg.sender?.available_name || '?'
}
